import { OnInit, Input, Component, NgZone } from "@angular/core";
import { StpConfigureService } from "../stp-configure.service";
import { MainPageService } from "../../../main-page/main-page.service";
import { ShowViewerArgs } from "../../../models/viewer/ShowViewerArgs.model";
import { PipeRingVariantConfigModel } from "../../../models/parts/pipering-variant-config.model";
import { UnitsConverter } from "../../../shared/units-converter/units-converter";
import { PipeRingModel } from "../../../models/parts/pipering.model.";
import { PiperingBossModel } from "../../../models/parts/pipering-boss.model";

@Component({
    selector: 'pipering-configure',
    template: `<div class="componnent-wrapper">
    <div class="col-7">
        <div style="margin-left: 10%">
        <img src="assets/images/pipeRing.png" width="60%" height="55%">
        <br>
        <img *ngIf="!configDisplay.isStandard" src="assets/images/insulation-legend.png" width="65%" height="45%">
    </div>
    </div>
    <div class="col-5">
        <div class="header-text">
            <span class="title-text">Pipe ring type:</span>
            <span *ngIf="configDisplay.isStandard"> Standard</span>
            <span *ngIf="!configDisplay.isStandard"> Cold pipe ring</span>
        </div>
        <div style="height: 60%;">
            <div class="btnStep display-flex">
                <span class="w-277"></span>
                <span class="input">min</span>
                <span class="input">max</span>
            </div>
            <ul class="list">
                <li class="step">
                    <div class="btnStep display-flex">
                        <span class="w-200">Clamping range</span>
                        <input class="input" type="number" min="0" [(ngModel)]="configDisplay.clampingRangeMin"
                            (keypress)="preventKeys($event)" (keyup)="saveVariantChanges()">
                        <input class="input" type="number" min="0" [(ngModel)]="configDisplay.clampingRangeMax"
                            (keypress)="preventKeys($event)" (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step" [hidden]="configDisplay.isDouble">
                    <div class="btnStep display-flex">
                        <span class="w-200">Center to Boss</span>
                        <input class="input" type="number" min="0" [(ngModel)]="configDisplay.centerToBoss" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex">
                        <span class="w-200">Width</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.width" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step" [hidden]="!configDisplay.isDouble">
                    <div class="btnStep display-flex">
                        <span class="w-200">Screw spacing</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.screwSpacing" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex">
                        <span class="w-200">Depth</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.depth" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex">
                        <span class="w-200">Min. Spacing Between</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.spacingBetween" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex">
                        <span class="w-200">Min. Spacing Above</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.spacingAbove" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex" [hidden]="configDisplay.isDouble">
                        <span class="w-200">Min. Adjustmen Length</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.adjustmentLength" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step">
                    <div class="btnStep display-flex" [hidden]="configDisplay.isDouble">
                        <span class="w-200">Boss reference</span>
                        <select [(ngModel)]="configDisplay.bossReference" (ngModelChange)="saveVariantChanges()">
                            <option *ngFor="let piperingBoss of piperingBossData" [ngValue]=piperingBoss.id>{{piperingBoss.name}}</option>
                        </select>
                    </div>
                </li>
                <li class="step" [hidden]="configDisplay.isStandard">
                    <div class="btnStep display-flex">
                        <span class="w-200">Insulation Thickness</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.insulationThickness" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
                <li class="step" [hidden]="configDisplay.isStandard">
                    <div class="btnStep display-flex">
                        <span class="w-200">External Diameter</span>
                        <input class="input" type="number" [(ngModel)]="configDisplay.externalDiameter" (keypress)="preventKeys($event)"
                            (keyup)="saveVariantChanges()">
                        <span>[mm]</span>
                    </div>
                </li>
            </ul>
        </div>
        <span [hidden]="!configDisplay.isStandard">Connection direction:</span>
        <div class="display-flex" [hidden]="!configDisplay.isStandard">
            <div class="margins">
                <img src="assets/images/ceiling-mount.png" alt="" width="50%" height="50%">
                <br>
                <input type="checkbox" [(ngModel)]="configDisplay.isCeiling" (change)="saveVariantChanges()">
            </div>
            <div class="margins">
                <img src="assets/images/ceiling-mount.png" alt="" class="rotate90" width="50%" height="50%">
                <br>
                <input type="checkbox" [(ngModel)]="configDisplay.isWall" (change)="saveVariantChanges()">
            </div>
            <div class="margins">
                <img src="assets/images/ceiling-mount.png" alt="" class="rotate180" width="50%" height="50%">
                <br>
                <input type="checkbox" [(ngModel)]="configDisplay.isFloor" (change)="saveVariantChanges()">
            </div>
        </div>
        <span>Mode:</span>
        <div class="display-flex e-margins">
            <div class="margins">
                <img src="assets/images/singleMount.png" alt="" width="50%" height="50%">
                <br>
                <input type="radio" [(ngModel)]="configDisplay.isDouble" [value]="false" (change)="mountingChange()">
            </div>
            <div class="margins">
                <img src="assets/images/doubleMount.png" alt="" width="50%" height="50%">
                <br>
                <input type="radio" [(ngModel)]="configDisplay.isDouble" [value]="true" (change)="mountingChange()">
            </div>
        </div>
    </div>
</div>`,
    styles: [`.buttonTransparent{padding:0;background-color:transparent;border:none}.buttonTransparent:disabled{opacity:.2}.arms-table-normal{bottom:41px;right:18px;background-color:#fff}.arms-table-narrow{bottom:41px;right:18px;width:36%;background-color:#fff}.display-flex{display:flex;align-items:center;margin-bottom:3px!important;margin-top:3px!important}.list{display:block;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.step:nth-child(7) .btnStep::before{content:"7"}.step:nth-child(8) .btnStep::before{content:"8"}.step:nth-child(9) .btnStep::before{content:"9"}.step:nth-child(10) .btnStep::before{content:"10"}.step:nth-child(11) .btnStep::before{content:"11"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.rotate90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.rotate180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.margins{margin-left:30px;text-align:center}.w-200{width:200px}.input{width:80px;margin-right:20px}.w-277{width:277px}.e-margins{margin-left:21px;margin-top:36px!important}.componnent-wrapper{height:100%;display:flex;margin-bottom:3px!important;margin-top:3px!important}.header-text{font-size:20px}.title-text{font-weight:700}`, `table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:1px}tr:nth-child(even){background-color:#ddd}.icon-button{cursor:pointer;font-size:30px;vertical-align:middle}.icon-button .close-icon{cursor:pointer;position:absolute;right:10px}.steps{display:flex;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.btnStep:disabled{opacity:.6!important;cursor:default}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.arms-table{bottom:41px;right:18px;height:100%;background-color:#fff}.arms-table td,.arms-table th{text-align:center}.red-button{font-family:inherit;padding:7px 14px}.currentTab::before{background-color:#d0021b!important}.display-flex{display:flex;margin-bottom:10px}`]
})

export class PiperingConfigureComponent implements OnInit {
    @Input() args: ShowViewerArgs;
    private pipering: PipeRingModel[];
    public piperingVariantConfig: PipeRingVariantConfigModel;
    public configDisplay: PipeRingVariantConfigModel;
    private unitsConverter = new UnitsConverter();
    public selectedUnit: string = 'mm';
    public piperingBossData: PiperingBossModel[] = [];

    @Input() set Args(value: ShowViewerArgs) {
        this.args = value;
        if (this.args !== null) {
            this.loadVariantData();
        }
    }

    constructor(private stpConfigureService: StpConfigureService, private mainPageService: MainPageService, private zone: NgZone) { }

    ngOnInit(): void {
        this.piperingVariantConfig = new PipeRingVariantConfigModel();
        this.configDisplay = new PipeRingVariantConfigModel();
    }

    loadVariantData(): void {
        this.mainPageService.getPiperingVariantConfigurationData(this.args.variantId).subscribe((response) => {
            if ((response.isEmpty !== undefined) ? response.isEmpty : false) {
                this.createNewConfig();
            } else {
                this.piperingVariantConfig = response;
                this.changeDisplayedUnits();
            }
        });
        this.mainPageService.loadAllPiperingBosses().subscribe((response) => {
            this.piperingBossData = response;
        })
    }

    createNewConfig() {
        this.mainPageService.getSpecificPipering(this.args.itemId).subscribe((res) => {
            this.pipering = res;
            this.piperingVariantConfig = new PipeRingVariantConfigModel();
            this.piperingVariantConfig._id = this.args.variantId;
            this.piperingVariantConfig.isStandard = !(this.pipering[0].piperingGroupId === 2 || this.pipering[0].piperingGroupId === 3);
            if (this.piperingVariantConfig.isStandard) {
                this.piperingVariantConfig.isCeiling = true;
            }
            this.piperingVariantConfig.isDouble = false;
            this.changeDisplayedUnits();
        });

    }

    preventKeys(event) {
        if (event.charCode === 45 || event.charCode === 69 || event.charCode === 101 || event.charCode === 43) {
            event.preventDefault();
        }
    }

    saveVariantChanges() {
        this.changeElementUnitsToSI();
        // this.piperingVariantConfig.bossReference = +this.piperingVariantConfig.bossReference;
        this.mainPageService.postPiperingVariantConfiguration(this.piperingVariantConfig).subscribe((response) => { });
    }

    private changeDisplayedUnits() {
        const tempObject = new PipeRingVariantConfigModel();
        tempObject._id = this.piperingVariantConfig._id;
        tempObject.isCeiling = this.piperingVariantConfig.isCeiling;
        tempObject.isFloor = this.piperingVariantConfig.isFloor;
        tempObject.isWall = this.piperingVariantConfig.isWall;
        tempObject.isDouble = this.piperingVariantConfig.isDouble;
        tempObject.isStandard = this.piperingVariantConfig.isStandard;
        tempObject.bossReference = (this.piperingVariantConfig.bossReference) ? null : this.piperingVariantConfig.bossReference.valueOf();
        tempObject.threadedRods = this.piperingVariantConfig.threadedRods;
        if (this.piperingVariantConfig.clampingRangeMax !== null) {
            tempObject.clampingRangeMax = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.clampingRangeMax, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.clampingRangeMin !== null) {
            tempObject.clampingRangeMin = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.clampingRangeMin, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.centerToBoss !== null) {
            tempObject.centerToBoss = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.centerToBoss, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.width !== null) {
            tempObject.width = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.width, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.screwSpacing !== null) {
            tempObject.screwSpacing = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.screwSpacing, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.depth !== null) {
            tempObject.depth = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.depth, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.spacingBetween !== null) {
            tempObject.spacingBetween = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.spacingBetween, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.spacingAbove !== null) {
            tempObject.spacingAbove = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.spacingAbove, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.adjustmentLength !== null) {
            tempObject.adjustmentLength = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.adjustmentLength, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.insulationThickness !== null) {
            tempObject.insulationThickness = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.insulationThickness, this.selectedUnit, 4);
        }
        if (this.piperingVariantConfig.externalDiameter !== null) {
            tempObject.externalDiameter = this.unitsConverter.convertFromSIToUnits(
                this.piperingVariantConfig.externalDiameter, this.selectedUnit, 4);
        }
        Object.assign(this.configDisplay, tempObject);
    }

    private changeElementUnitsToSI() {
        const tempObject = new PipeRingVariantConfigModel();
        tempObject._id = this.configDisplay._id;
        tempObject.isCeiling = this.configDisplay.isCeiling;
        tempObject.isFloor = this.configDisplay.isFloor;
        tempObject.isWall = this.configDisplay.isWall;
        tempObject.isDouble = this.configDisplay.isDouble;
        tempObject.isStandard = this.configDisplay.isStandard;
        tempObject.bossReference = (this.piperingVariantConfig.bossReference) ? null : this.piperingVariantConfig.bossReference.valueOf();
        tempObject.threadedRods = this.configDisplay.threadedRods;
        if (this.configDisplay.clampingRangeMax !== null) {
            tempObject.clampingRangeMax = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.clampingRangeMax, this.selectedUnit);
        }
        if (this.configDisplay.clampingRangeMin !== null) {
            tempObject.clampingRangeMin = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.clampingRangeMin, this.selectedUnit);
        }
        if (this.configDisplay.centerToBoss !== null) {
            tempObject.centerToBoss = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.centerToBoss, this.selectedUnit);
        }
        if (this.configDisplay.width !== null) {
            tempObject.width = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.width, this.selectedUnit);
        }
        if (this.configDisplay.screwSpacing !== null) {
            tempObject.screwSpacing = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.screwSpacing, this.selectedUnit);
        }
        if (this.configDisplay.depth !== null) {
            tempObject.depth = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.depth, this.selectedUnit);
        }
        if (this.configDisplay.spacingBetween !== null) {
            tempObject.spacingBetween = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.spacingBetween, this.selectedUnit);
        }
        if (this.configDisplay.spacingAbove !== null) {
            tempObject.spacingAbove = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.spacingAbove, this.selectedUnit);
        }
        if (this.configDisplay.adjustmentLength !== null) {
            tempObject.adjustmentLength = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.adjustmentLength, this.selectedUnit);
        }
        if (this.configDisplay.insulationThickness !== null) {
            tempObject.insulationThickness = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.insulationThickness, this.selectedUnit);
        }
        if (this.configDisplay.externalDiameter !== null) {
            tempObject.externalDiameter = this.unitsConverter.convertFromUnitsToSI(
                this.configDisplay.externalDiameter, this.selectedUnit);
        }
        Object.assign(this.piperingVariantConfig, tempObject);
    }

    mountingChange() {
        if (this.configDisplay.isDouble) {
            this.configDisplay.centerToBoss = null;
            this.configDisplay.adjustmentLength = null;
        } else {
            this.configDisplay.screwSpacing = null;
        }
        this.saveVariantChanges();
    }
}
